import React from 'react';
import { companyInfo } from '../data/mock';
import { Phone } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen bg-black pt-20 overflow-hidden">
      {/* Background subtle pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #D4AF37 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1 animate-fade-in-up">
            {/* Logo large */}
            <div className="mb-8">
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-24 md:h-32 w-auto object-contain"
              />
            </div>

            {/* Main Title */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6">
              Trámites notariales, migratorios y legales para la{' '}
              <span className="gold-text">comunidad hispana</span>
            </h1>

            {/* Subtitle */}
            <p className="text-lg md:text-xl text-white/70 mb-10 leading-relaxed max-w-xl">
              Atención clara, profesional y en español.
              <br />
              Estamos aquí para ayudarte.
            </p>

            {/* CTA Button */}
            <div className="space-y-4">
              <a
                href={companyInfo.telLink1}
                className="inline-flex items-center gap-3 btn-primary-custom px-8 py-4 text-base font-semibold"
              >
                <Phone className="h-5 w-5" />
                No dudes en llamarnos
              </a>

              {/* Secondary phone */}
              <p className="text-white/50 text-sm">
                También atendemos al:{' '}
                <a
                  href={companyInfo.telLink2}
                  className="text-[#D4AF37] hover:text-[#E8C554] transition-colors"
                >
                  {companyInfo.phone2}
                </a>
              </p>
            </div>
          </div>

          {/* Wilson Photo */}
          <div className="order-1 lg:order-2 animate-slide-in-right">
            <div className="relative">
              {/* Gold border frame */}
              <div className="absolute -inset-4 border-2 border-[#D4AF37]/30" />
              <div className="absolute -inset-2 border border-[#D4AF37]/50" />
              
              {/* Image */}
              <div className="relative image-container bg-black">
                <img
                  src={companyInfo.wilsonPhoto}
                  alt="Wilson Cruz - Inmigración Hispana Multi Services"
                  className="w-full h-auto object-contain max-h-[600px]"
                />
              </div>

              {/* Decorative element */}
              <div className="absolute -bottom-6 -right-6 w-24 h-24 border-2 border-[#D4AF37]/40" />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gold line */}
      <div className="absolute bottom-0 left-0 right-0 gold-divider" />
    </section>
  );
};

export default HeroSection;
